import {
  Row,
  RowContainer,
} from "@circle-react-uikit/SkeletonLoader/components";

export interface EventItemProps {
  isMobileView?: boolean;
}

export const EventItem = ({ isMobileView = false }: EventItemProps) => (
  <div className="w-full">
    <RowContainer full>
      <Row lg short className="!h-6" />
    </RowContainer>
    {isMobileView ? (
      <div className="mt-4 flex flex-col justify-start gap-y-3">
        <Row md almostFull />
        <Row md long className="!w-32" />
      </div>
    ) : (
      <div className="my-4 flex flex-col justify-start gap-y-3">
        <Row md almostFull />
      </div>
    )}
  </div>
);
